var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15433 0.646447C3.95907 0.451184 3.64249 0.451184 3.44723 0.646447L0.265247 3.82843C0.0699853 4.02369 0.0699853 4.34027 0.265247 4.53553C0.46051 4.7308 0.777092 4.7308 0.972354 4.53553L3.80078 1.70711L6.62921 4.53553C6.82447 4.7308 7.14105 4.7308 7.33632 4.53553C7.53158 4.34027 7.53158 4.02369 7.33632 3.82843L4.15433 0.646447ZM3.44723 13.3536C3.64249 13.5488 3.95907 13.5488 4.15434 13.3536L7.33632 10.1716C7.53158 9.97631 7.53158 9.65973 7.33632 9.46447C7.14105 9.2692 6.82447 9.2692 6.62921 9.46447L3.80078 12.2929L0.972355 9.46447C0.777092 9.2692 0.46051 9.2692 0.265248 9.46447C0.0699855 9.65973 0.0699855 9.97631 0.265248 10.1716L3.44723 13.3536ZM3.30078 1L3.30078 13L4.30078 13L4.30078 1L3.30078 1Z",
    fill: "#9F9DA9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.9793acf8ba45bf6617f941f8cda38633.svg";
export { ForwardRef as ReactComponent };